<template>
    <ToolbarButton
        :icon="refreshIcon"
        label="Refresh"
        @click.native="refresh()"/>
</template>

<script>
import RefreshIcon from 'voluum-frontend-icons/refresh.svg';

import Icon from './Icon';
import ToolbarButton from './ToolbarButton';

export default {
    name: 'RefreshButton',

    components: {
        Icon,
        ToolbarButton
    },

    data: function () {
        return {
            refreshIcon: RefreshIcon
        };
    },

    methods: {
        refresh: function () {
            this.$store.dispatch('loadReport');
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/RefreshButton.vue